import { defineComponent as e } from "vue";
import "./Snake.css";
const o = e({
  name: "Snake",
  props: {
    size: { type: Number, default: 0 },
    color: { type: String, default: "" }
  },
  computed: {
    spinnerColor() {
      return this.color || "#ccc";
    },
    spinnerSize() {
      return (this.size || 28) + "px";
    }
  }
});
export {
  o as default
};
